import { FC } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useSlideSave } from '../lib/FabricJs/providers/SaveProvider';

const RecoveryDialog: FC = () => {
  const { recovery, resolveRecovery } = useSlideSave();
  if (recovery.state !== 'prompt') return null;

  const changedAt = new Date(recovery.copy.changedAt).toLocaleString();

  return (
    <Dialog open aria-labelledby="recovery-dialog-title">
      <DialogTitle id="recovery-dialog-title">
        Restore unsaved changes?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          This slide has changes from {changedAt} that were never saved.
        </DialogContentText>
        {recovery.outdated && (
          <DialogContentText sx={{ mt: 2 }}>
            The slide has been saved since then. Restoring and saving these
            changes will replace that newer version.
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => resolveRecovery(false)}>Discard them</Button>
        <Button variant="contained" onClick={() => resolveRecovery(true)}>
          Restore
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecoveryDialog;
